import React, { useReducer, createContext, useContext } from 'react';
import PropTypes from 'prop-types';

import { InitialStatePropType } from '@propTypes';
import { reducer, actions } from '@store';

const TopbannerContext = createContext();

export const useTopbannerContext = () => useContext(TopbannerContext);

export const TopbannerProvider = ({ initialState, children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { browserAPI, hasTopbannerBeenFetched } = state;

  const getTopbanner = (
    platform,
    market,
    pageName,
    ancestors,
    userId,
    isNewUser,
  ) => {
    if (!hasTopbannerBeenFetched) {
      actions.getTopbanner(
        browserAPI,
        platform,
        market,
        pageName,
        ancestors,
        userId,
        isNewUser,
      )(dispatch);
    }
  };

  return (
    <TopbannerContext.Provider value={{ ...state, getTopbanner }}>
      <div style={{ boxShadow: 'inset 0 -1px 0 0 #ECEDF0' }}>{children}</div>
    </TopbannerContext.Provider>
  );
};

TopbannerProvider.propTypes = {
  children: PropTypes.node.isRequired,
  initialState: InitialStatePropType.isRequired,
};

export default TopbannerContext;
